/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import DailyPrice, { DailyPriceProps } from './DailyPrice';
import dailyPriceStyles, { themeDailyPriceStyles } from './dailyPrice.styles';

interface WidgetProperties extends commonTypes.WidgetPropertiesBase, DailyPriceProps {
    typographyClass?: string;
}

const DailyPriceWrapper = (props: commonTypes.WidgetInstanceProps): JSX.Element => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const {
        date,
        price,
        priceChange,
        percentageChange,
        percentageUpIcon,
        percentageDownIcon,
        styles,
        showIcon,
        iconPosition,
    } = widgetProperties;
    const { data } = props;
    const i18n = commonHooks.useLocalization();
    const theme = data?.themeSelected || props?.theme;

    const priceBinding = i18n.format(price || '', data);
    const dateBinding = i18n.format(date || '', data);
    const priceChangeBinding = i18n.format(priceChange || '', data);
    const percentageChangeBinding = i18n.format(percentageChange || '', data);

    return (
        <div
            className={widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''}
            css={css`
                ${!theme ? dailyPriceStyles : themeDailyPriceStyles}${getTextSchemaProperties(
                    widgetProperties,
                    data?.colorSpace
                )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                    widgetProperties
                )}${styles}
            `}
        >
            <DailyPrice
                date={dateBinding}
                price={priceBinding}
                priceChange={priceChangeBinding}
                percentageChange={percentageChangeBinding}
                showIcon={showIcon}
                iconPosition={iconPosition}
                percentageUpIcon={percentageUpIcon}
                percentageDownIcon={percentageDownIcon}
            />
        </div>
    );
};

export default DailyPriceWrapper;
